const players = new Map();
const lifetime = 2 * 60 * 1000;
const limit = 3;
let generation = 0;

export const videoCacheGeneration = () => generation;
export function clearVideoPlayers() {
  generation++;
  for (const key of players.keys()) remove(key);
}

function remove(key) {
  const entry = players.get(key);
  if (!entry) return;
  players.delete(key);
  clearTimeout(entry.timer);
  entry.player.dispose();
}

export function takeVideoPlayer(key) {
  const entry = players.get(key);
  if (!entry) return null;
  players.delete(key);
  clearTimeout(entry.timer);
  return entry;
}

export function retainVideoPlayer(key, entry) {
  if (!key || entry.generation !== generation || entry.player.isDisposed() || entry.player.error()) {
    if (!entry.player.isDisposed()) entry.player.dispose();
    return;
  }
  remove(key);
  entry.player.pause();
  entry.player.el().remove();
  entry.timer = setTimeout(() => remove(key), lifetime);
  players.set(key, entry);
  while (players.size > limit) remove(players.keys().next().value);
}
